import { render, staticRenderFns } from "./manping.vue?vue&type=template&id=2f3bf962&scoped=true&"
import script from "./manping.vue?vue&type=script&lang=js&"
export * from "./manping.vue?vue&type=script&lang=js&"
import style0 from "./manping.vue?vue&type=style&index=0&id=2f3bf962&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3bf962",
  null
  
)

export default component.exports